import { useState, useEffect } from "react";

const useInView = (ref) => {
    const [inView, setInView] = useState(false)
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setInView(entry.isIntersecting)
        },
            { threshold: 0.5 }
        )
        if (ref.current) {
            observer.observe(ref.current)
        }
        return () => {
            if (ref.current) {
                observer.unobserve(ref.current)
            }
        }
    }, [ref])


    return inView
}

export default useInView